class Brands {
    constructor(section) {
        if (!section) return;

        this.section = section;
        this.placeholder = this.section.querySelector('.brands-list__image-wrapper');
        this.brandList = this.section.querySelector('.brands-list');
        this.brandLetters = this.section.querySelector('.brands-letters');
        this.brandLetterLinks = this.brandLetters.querySelectorAll('.brands-letters .letter a');
        this.comingFromCollection = new URLSearchParams(window.location.search).get('collection');
        this.comingFromType = new URLSearchParams(window.location.search).get('type');

        if (this.placeholder && this.placeholder.querySelector("img")) {
            this.placeholderSrc = this.placeholder.querySelector("img").src;
        }

        this.init();
    }

    init() {
        this.getCollections();
        this.addCollections();
        this.addLettersStickyHeader();
        this.setDisabledLetters();
    }

    getCollections() {
        this.brandsData = this.section.querySelector("#collection-data");
        this.brandsData = JSON.parse(this.brandsData.textContent);
        if (!this.brandsData) return;

        if (this.brandList) this.brands = this.brandList.querySelectorAll('.brands-item');

        this.mainCollection = this.brandsData[this.comingFromCollection];
        if (this.mainCollection) {
            this.section.querySelector('[data-main-collection]').textContent = this.mainCollection.title;
        }

        if (this.comingFromType) {
            const capitalizedType = this.comingFromType.charAt(0).toUpperCase() + this.comingFromType.slice(1);
            if (this.mainCollection) {
                this.section.querySelector('[data-main-collection]').textContent = this.mainCollection.title + "/" + capitalizedType;
            }
        }

        // filter the brands data based on the collection
        this.brandsDataFiltered = Object.keys(this.brandsData).map((brand) => {

            if (this.brandsData[brand].url.toLowerCase().includes(this.comingFromCollection.toLowerCase())) {
                if (this.comingFromType) {
                    if (this.brandsData[brand].type.toLowerCase() == this.comingFromType.toLowerCase()) {
                        return this.brandsData[brand];
                    }
                } else {
                    return this.brandsData[brand];
                }
            }
        });
    }

    addCollections() {
        // clean up the array
        this.brandsDataFiltered = this.brandsDataFiltered.filter((brand) => {
            return brand != undefined;
        });


        this.brandTemplate = document.querySelector("#brand-item-template");
        for (const brand of this.brandsDataFiltered) {
            const newBrand = this.brandTemplate.content.cloneNode(true);
            newBrand.querySelector("h2 span").textContent = brand.title.replace();
            newBrand.querySelector("a").href = brand.url;
            newBrand.querySelector("a").setAttribute("data-letter", `${brand.title.charAt(0).toUpperCase()}`);
            newBrand.querySelector("img").src = brand.img;
            this.brandList.appendChild(newBrand);
        }

        document.querySelectorAll(".brands-item").forEach((brand) => {
            brand.addEventListener('mouseover', this.onMouseOver.bind(this));
        });
    }

    setDisabledLetters() {
        const _this = this;
        const letters = _this.brandList.querySelectorAll('.brands-item');
        const existingLetters = [];

        letters.forEach((letter) => {
            const letterText = letter.getAttribute('data-letter');
            if (!existingLetters.includes(letterText)) {
                existingLetters.push(letterText);
                letter.id = letterText;
            }
        });

        _this.brandLetterLinks.forEach((letterLink) => {
            if (letterLink.textContent == '0-9' || letterLink.textContent == 'All') return;
            if (!existingLetters.includes(letterLink.textContent)) {
                letterLink.classList.add('is-disabled');
            }
        });
    }

    addLettersStickyHeader() {
        const headerEl = this.brandLetters;
        const sentinalEl = document.querySelector(".brands-list__top-sentinal")


        const intersectionObserverCallback = (entries) => {
            if (!entries[0].isIntersecting) {
                headerEl.classList.add('is-sticky')
            } else {
                headerEl.classList.remove('is-sticky')
            }
        }

        const observerOptions = {
            attributes: true,
            attributeFilter: ['class'],
            childList: false,
            subtree: false
        };

        const headerObserverCallback = (mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    // Check if the 'shown' class has been added
                    if (mutation.target.classList.contains('show')) {
                        headerEl.classList.add('header-shown');
                    } else {
                        headerEl.classList.remove('header-shown');
                    }
                }
            }
        };

        const intersectionObserver = new window.IntersectionObserver(intersectionObserverCallback)
        intersectionObserver.observe(sentinalEl)

        const headerMutationObserver = new MutationObserver(headerObserverCallback);
        const header = document.querySelector(".sticky-header");
        headerMutationObserver.observe(header, observerOptions);
    }

    onMouseOver(event) {
        const brand = event.currentTarget;
        const placeholderImg = this.placeholder.querySelector("img");

        if (this.placeholder && placeholderImg) {
            const brandImg = brand.querySelector('.brands-list__image');
            if (brandImg && brandImg.getAttribute('src') != '') {
                placeholderImg.setAttribute('src', brandImg.src);
            } else if (brandImg.getAttribute('src') == '') {
                placeholderImg.setAttribute('src', this.placeholderSrc);
            }
        }
    }
}

const brandsSections = document.querySelectorAll('.shopify-section.section-brands');
if (!brandsSections.length > 0) return;

brandsSections.forEach((brandsSection) => {
    if (brandsSection) {
        new Brands(brandsSection);
    }
});